import React, { useState } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TextField,
    Button, Stack, Tooltip, IconButton,
    Select, MenuItem,
    Box, Grid, Typography
} from '@mui/material';
import TableRowActions from '../TableRowActions';
import borderStyle from '../../styles/borderStyle';
import tableStyle from '../../styles/tableStyle';
import buttonStyle from '../../styles/buttonStyle';
import RowDelete from '../RowDelete';
import RemoveCircleOutlinedIcon from '@mui/icons-material/RemoveCircleOutlined';

const firstRow = {
    description: "",
    id: 1,
    hrRate: "",
    hrs: "",
    actualHr: "",
    vat: '20.00',
    amt: ""
}
function AddPartsTask({ rowsPart, setRowsPart, addRowParts, deleteRowParts }) {
    // const [rows, setRows] = useState([]);
    const [hoveredRow, setHoveredRow] = useState(null);


    const handleRowMouseEnter = (rowId) => {
        setHoveredRow(rowId);
    };

    const handleRowMouseLeave = () => {
        setHoveredRow(null);
    };
    const columns = [
        { id: 'id', label: 'No' },
        { id: 'description', label: 'Parts' },
        { id: 'qty', label: 'Qty' },
        { id: 'costRate', label: 'Cost Rate' },
        { id: 'markup', label: 'Mark Up %' },
        { id: 'vat', label: 'VAT' },
        { id: 'trade', label: 'Trade Rate' },
        { id: 'amt', label: 'Amount' },
    ];

    // const addRow = (field) => {
    //     const lastRow = rows[rows.length - 1];
    //     // Check if the last row's "name" field is empty or if it's the same as a previously added row
    //     if (!lastRow || lastRow[field] === '') {
    //       alert('Please fill in all fields before adding a new row.');
    //       return;
    //     }     
    //     // Check for duplicate names
    //     if (rows.slice(0, rows.length - 1).some((row) => row[field] === lastRow[field])) {
    //       alert('Item already added.');
    //       return;
    //     }    
    //     const newRow = { ...firstRow, id: rows.length+1 }; // Modify as needed
    //     setRows([...rows, newRow]);
    // };

    const handleFieldChange = (e, id, field) => {
        const updatedRows = rowsPart.map((row) => {
            if (row.id === id) {
                row[field] = e.target.value;

                // Recalculate the "Amount"
                if (field === 'qty' || field === 'costRate' || field === 'markup') {
                    row.trade = parseFloat((parseFloat(row.costRate) * parseFloat((row.markup / 100)))) + parseFloat(row.costRate)
                    row.amt = (parseFloat((parseFloat(row.costRate) * parseFloat((row.markup / 100)))) + parseFloat(row.costRate)) * row.qty
                }
            }
            return row;
        });
        setRowsPart(updatedRows);
    };

    const calculateTotalAmount = () => {
        const totalAmount = rowsPart.reduce((accumulator, row) => {
            return accumulator + parseFloat(row.amt || 0);
        }, 0);
        return totalAmount;
    };

    return (
        <TableContainer component={Paper}>
            <Table aria-label="sticky table" size="small" sx={{ minWidth: 1000 }}>
                <TableHead>
                    <TableRow>
                        {columns.filter(item => item.id !== 'vat').map((column) => (
                            <TableCell key={column.id} style={column.id === 'description' ? { width: 400 } : { width: 100 }}>
                                <b>{column.label}</b>
                            </TableCell>
                        ))}
                        <TableCell></TableCell> {/* Placeholder for delete button column */}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rowsPart.map((row) => (
                        <TableRow key={row.id} onMouseEnter={() => handleRowMouseEnter(row.id)} onMouseLeave={() => handleRowMouseLeave(row.id)}>
                            <TableCell>{row.id}</TableCell>
                            <TableCell>
                            {row.partsId ?  row.description :
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    value={row.description}
                                    onChange={(e) => handleFieldChange(e, row.id, 'description')}
                                />
                              }
                            </TableCell>
                            <TableCell>
                                <TextField
                                    InputProps={{
                                        style: tableStyle.root
                                    }}
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    value={row.qty}
                                    onChange={(e) => handleFieldChange(e, row.id, 'qty')}
                                />
                            </TableCell>
                            <TableCell>
                                <TextField
                                    InputProps={{
                                        style: tableStyle.root
                                    }}
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    value={row.costRate}
                                    onChange={(e) => handleFieldChange(e, row.id, 'costRate')}
                                />
                            </TableCell>
                            <TableCell>
                                <TextField
                                    InputProps={{
                                        style: tableStyle.root
                                    }}
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    value={row.markup}
                                    onChange={(e) => handleFieldChange(e, row.id, 'markup')}
                                />
                            </TableCell>

                            {/* <TableCell>
                                <TextField
                                    InputProps={{
                                        style: tableStyle.root
                                    }}
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    value={row.vat}
                                    onChange={(e) => handleFieldChange(e, row.id, 'vat')}
                                />
                            </TableCell> */}
                            <TableCell>
                                {row.trade}
                            </TableCell>
                            <TableCell>
                                {/* <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    value={row.amt}
                    onChange={(e) => handleFieldChange(e, row.id, 'amt')}
                /> */}
                                {row.amt}
                            </TableCell>

                            <TableCell>
                                <Stack direction='row' spacing={1}>
                                    {row.id === hoveredRow &&
                                        <Tooltip title="Remove">
                                            <IconButton size='small' onClick={() => { deleteRowParts(row.id, 'empty') }} >
                                                <RemoveCircleOutlinedIcon />
                                            </IconButton>
                                        </Tooltip>
                                    }

                                </Stack>
                                {/* <RowDelete rows={rowsPart} rowId={row.id} setRows={setRowsPart} firstRow={firstRow} field='vat' hoveredRow={hoveredRow} handleDelete={handleDelete}/> */}
                            </TableCell>
                        </TableRow>
                    ))}
                    <TableRow>
                        <TableCell colSpan={5}><Button onClick={() => addRowParts([firstRow])} variant='contained' sx={{ height: '30px', backgroundColor: '#489C8F', display: 'flex', alignItems: 'center' }}>Add parts</Button></TableCell>
                        <TableCell ><b>Total</b></TableCell>
                        <TableCell >{calculateTotalAmount()}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>

    )
}

export default AddPartsTask

